import { getBimModelAttributesList, getDrawingUrl } from "@/api/api";
import axios from "axios";
const PDF = () => import("@/components/common/pdf/Index.vue");
export default {
  components: { PDF },
  props: ["modelTitle", "modelTender"],
  data() {
    return {
      pdfSrc: null,
      propertyList_show: true,
      modelAttributesData: [
        // //el-table的数据内容
        // {
        //   pkey: "桥梁名称",
        //   pvalue: "K1+999.40跨线桥",
        // },
        // {
        //   pkey: "桥梁长度",
        //   pvalue: "70.62米",
        // },
        // {
        //   pkey: "跨径组合",
        //   pvalue: "4x16",
        // },
        // {
        //   pkey: "交叉角度",
        //   pvalue: "75度",
        // },
        // {
        //   pkey: "主梁类型",
        //   pvalue: "预应力砼（后张）空心板",
        // },
        // {
        //   pkey: "主梁片数",
        //   pvalue: "20",
        // },
        // {
        //   pkey: "最大墩高",
        //   pvalue: "4.651米",
        // },
      ],
      isFold: false,
    };
  },
  mounted() {
    // this.$refs["multipleTable"].$nextTick(function () {
    //            this.escrollY(
    //              ".el-table__body-wrapper",
    //              ".el-table__header-wrapper"
    //            );
    // 		   console.log('触发！');
    //          })
  },
  methods: {
    rowClick(item) {
      if (item.Alias === "设计图纸") {
        // 请求
        getDrawingUrl({
          DrawingCode: item.Value,
          Tender: this.modelTender,
        }).then((res) => {
          this.pdfSrc =
            process.env.VUE_APP_LOCAL_RESOURCES_PATH + res.data.data;
          axios
            .get(this.pdfSrc)
            .then((res) => {
              this.$refs.PDF.isShow = true;
            })
            .catch((err) => {
              this.$notify({
                title: "该图纸不存在！",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            });
        });
      }
    },
    getList(fullName) {
      this.modelAttributesData = [];
      getBimModelAttributesList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
        fullName: fullName,
      })
        .then((res) => {
          if (
            res.data.code == 200 &&
            res.data.data.length > 0 &&
            res.data.data[0].attributes
          ) {
            //都安项目放开筛选限制
            if (sessionStorage.getItem("nowProjectId") == "255513056948293") {
              var modelAttributesData = res.data.data[0];
            } else {
              var modelAttributesData = res.data.data.find((item) => {
                return item.attributes.indexOf("桥梁名称") >= 0;
              });
            }
            if (modelAttributesData)
              this.modelAttributesData = JSON.parse(
                modelAttributesData.attributes
              );
          }
        })
        .catch((error) => {
          console.log(error);
          // this.modalNode.program.loading = false;
          this.$notify({
            title: "获取数据失败，请稍后再试",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.close();
        });
    },
    propertyList_click() {
      //this.propertyList_show=false;
      //alert("触发");
      this.$emit("propertyList_hide");
    },
  },
  watch: {
    modelTitle(newVal) {
      console.log(newVal);

      this.getList(newVal);
    },
  },
};
//console.log(localStorage.getItem(ColorPicker));
